import React from "react";
import "../Section2/section2.css";

function Section6() {
  return (
    <div className="Section2">
      <div className="Section2-one">
        <h1>MEET YOUR</h1>
        <h1>INSTRUCTORS</h1>
      </div>
      <div className="Section2-two">
        <p>
          ​Learn from industry experts with decades of big-tech experience.
          We’re ready to help you get hired!
        </p>
      </div>
    </div>
  );
}

export default Section6;
